module.exports = __webpack_public_path__ + "fonts/latoblackitalic.2e26a916.ttf";